import { render, staticRenderFns } from "./MessagePreferences.vue?vue&type=template&id=538bf632"
import script from "./MessagePreferences.vue?vue&type=script&lang=js"
export * from "./MessagePreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports